import { createContext, Dispatch } from 'react';

import { ReducerState, ReducerActions, blankState } from './SellerApplicationFormReducer';

const SellerOmtReturnReviewContext = createContext<{
    dispatch: Dispatch<ReducerActions>;
    state: ReducerState;
}>({
    dispatch: () => {},
    state: blankState,
});

export default SellerOmtReturnReviewContext;
